<template lang="pug">
    v-container( fluid px-5 )
        model-data-table( 
          v-model="items"
          :headers="headers"
          no-search-box
          no-search
          no-remove
          no-filter
          @detail="submitShow($event)"
          )
        dialog-t-account(ref="refDialogTAccount" :tAccountObj="tAccountObj")
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { fetchById } from '@/services/api/ledger'
import HeadersLedgerDetails from './HeadersLedgerDetails'
import LedgerIncludes from '@/services/api/ledger/LedgerIncludes'
import DialogTAccount from './DialogTAccount'
import ModelDataTable from '../../components/reusable_components/next/ModelDataTable'
import AccLedger from '../../models/Accounting/AccLedger'
//-
export default {
    name: 'details-ledger',
    // props: {},
    data: function() {
        return {
            headers: HeadersLedgerDetails,
            tAccountObj: {},
            items: [],
        }
    },
    computed: {
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
    },
    methods: {
        // -- UI Modification
        submitShow: function(event) {
            this.tAccountObj = event.item
            this.$refs.refDialogTAccount.open = true
        },
        // -- Data fetching
        getLedger: async function() {
            let ledger = await new AccLedger()
                .include(...LedgerIncludes)
                .find(this.$route.params.id)
            this.items = ledger.acc_detail_ledgers.map(det => {
                det.acc_account_comment = det.acc_account.comment
                return det
            })
        },
        // -- Data handling and transformations
        // -- Validations and Error handling
        // -- Other functions
        // -- Vuex mappings
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
    },
    // watch: {},
    components: {
        'model-data-table': ModelDataTable,
        'dialog-t-account': DialogTAccount,
    },
    // mixins: [],
    // filters: {},
    // -- Lifecycle Methods
    mounted: async function() {
        this.setTitleTopBar('Detalle de libro mayor')
        await this.getLedger()
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_DETAIL_ACCOUNTING_LEDGER'))
                ctx.$router.push('/')
        })
    },
    // -- End Lifecycle Methods
}
</script>

<style lang="scss">
</style>
